export enum AuthorTypeEnum {
  Trainer = "trainer",
  Client = "client",
  System = "system",
  Admin = "admin",
  Sales = "sales",
  /** TRE-1613 — notes written by the client-advisor note extractor, not by a human. */
  Agent = "agent",
}
